import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useId } from "../../hooks/use-id";

/**
 * Componente que muestra las preguntas y respuestas correspondientes al perfil
 * @param {object} interfaceTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} ProfileHelp
 */
export const ProfileHelp = ({interfaceTexts}) => {
    const titleId = useId('profile-title');
    return (
        <section aria-labelledby={titleId}>
            <Link to={'/ayuda'} className="secondary-button py-2 px-3 focusable-red"  aria-label={interfaceTexts?.accesibilidad?.volver || "Volver a la página de ayuda"}>
                <Icon icon="material-symbols:arrow-back-rounded" width="24" height="24" />
                {interfaceTexts?.botones?.volver || 'volver'}
            </Link>

            <h2 id={titleId} className="my-4">{interfaceTexts?.perfil?.titulo || 'Perfil'}</h2>
        </section>
    )
}